<template>
  <div class="textarea__wrap">
    <textarea
      type="text"
      :id="keyName"
      :name="keyName"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
    ></textarea>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: [
    'keyName',
    'value',
    'placeholder',
  ],
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.textarea__wrap {
  box-sizing: border-box;
}
textarea {
  width: 100%;
  height: 100px;
  padding: 5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  resize: none;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  font-size: 16px;
}
</style>